import { useApi } from '@/api';
import { KpiSkeleton, KpiCard } from '@/components';
import {
  Flex,
  CryptoIcon,
  CurrencyValue,
  PercentageValue,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  Box
} from '@blockanalitica/ui';

export default function OverviewKpis() {
  const [data, error] = useApi({
    url: '/at-risk/osm/'
  });

  if (error) {
    throw error;
  }

  const kpiConfig = data
    ? Object.keys(data).reduce((acc, key) => {
        const entry = data[key];
        acc[key] = {
          title: `${entry.collateral_symbol} OSM Price`,
          symbolField: 'collateral_symbol',
          addressField: 'collateral_address'
        };
        return acc;
      }, {})
    : {};

  const renderKpiCard = (key, config) => {
    const kpiData = data[key];
    if (!kpiData) return null;

    return (
      <KpiCard
        title={
          <Flex flexBasis="100%" gap="3xs" alignItems="center">
            <CryptoIcon
              name={kpiData[config.symbolField]}
              address={kpiData[config.addressField]}
            />
            <Flex justifyContent="flex-start" gap="3xs">
              {kpiData[config.symbolField]} OSM Price
            </Flex>
          </Flex>
        }
        data={kpiData}
        field="osm_price"
        options={{ currency: 'USD' }}
        footer={
          <Flex alignItems="baseline" gap="xs" width="95%" fontSize="0">
            <>Next OSM price:</>
            <CurrencyValue
              value={Number(kpiData.next_price)}
              options={{ notation: 'standard', currency: 'USD' }}
            />
            <Box fontSize="1">
              <Tooltip>
                <TooltipTrigger>
                  <PercentageValue
                    value={kpiData.next_price_change_percentage}
                    options={{
                      tooltip: false,
                      trend: true,

                      formatPercentageOptions: {
                        maximumFractionDigits: 2
                      }
                    }}
                  />
                </TooltipTrigger>
                <TooltipContent>
                  <CurrencyValue
                    value={kpiData.next_price_change}
                    options={{
                      currency: '',
                      tooltip: false,
                      iconSize: '0'
                    }}
                  />
                </TooltipContent>
              </Tooltip>
            </Box>
          </Flex>
        }
      />
    );
  };

  let content;
  if (data) {
    const kpiCards = Object.keys(kpiConfig).map((key) =>
      renderKpiCard(key, kpiConfig[key])
    );
    content = (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        {kpiCards}
      </Flex>
    );
  } else {
    content = (
      <>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
      </>
    );
  }

  return content;
}
